import React, { useEffect, useRef } from 'react';
import createGlobe from 'cobe';
import Modal from './modal'
import CopyLinkButton from './copy-link-button';
import { kebabCase } from 'lodash';
import parse from "html-react-parser"

export default function Infographic({ props }) {
  const { infographicItem, heading, leadContent, includeInStickyMenu } = props
  return (
    <>
      <section className={`m-section px-8`}>
        <div className='max-w-4xl mx-auto'>
          <div className="group-copy-link group grid grid-cols-1 justify-center text-center">
            {heading ? (
              <>
                <h2
                  className={`mb-4 anchor-link text-ar24-blue-900`}
                  id={kebabCase(heading).replace(/[0-9]/g, "")}
                >
                  {heading}
                </h2>
                <CopyLinkButton heading={heading} />
              </>
            ) : includeInStickyMenu?.menuTitle ? (
              <div id={kebabCase(includeInStickyMenu.menuTitle) || ""}>
                <CopyLinkButton heading={includeInStickyMenu.menuTitle} />
              </div>
            ) : null}
            {leadContent ? (
              <div
                className={`mb-4`}
              >
                {parse(leadContent)}
              </div>
            ) : null}
          </div>
        </div>
        <div className={`relative min-h-[36rem] mx-auto flex-col max-w-4xl flex items-center justify-center`}>

          <div className='relative'>
            <div className='absolute grayscale inset-0 bg-page-circle-logo opacity-30 bg-contain bg-no-repeat  bg-center animate-[spin_20s_linear_infinite_reverse] ' />
            <Earth />
          </div>

          <ol className='grid lg:absolute inset-0 gap-2'>
            {infographicItem?.map((item, index) => {
              const { heading, subheading, icon, modal } = item
              const button =
                <div className={`flex items-center p-3 sm:py-4 sm:px-5 gap-2 w-auto rounded-lg max-w-sm overflow-clip group relative lg:absolute shadow-xl ${index === 0 ? "lg:top-8 lg:left-8" : index === 1 ? "lg:top-20 lg:right-8" : index === 2 ? "lg:bottom-8 lg:right-0" : "lg:bottom-20 lg:left-8"}`}>
                  <div className='absolute inset-0 bg-white/80'>
                    <div className={`bg-circles-blue opacity-30 blur-2xl bg-cover absolute inset-0 transition ${modal ? "group-hover:opacity-20" : ""}`} style={{ backgroundPosition: `${index * 10}, ${index * 10}` }} /></div>
                  {icon?.localFile?.publicURL ? <img
                    src={icon.localFile.publicURL}
                    alt={icon.alt || heading}
                    className={`relative w-7 sm:w-10 ${modal ? "hover-grow" : ""}`}
                  /> : null}
                  <div>
                    <h3 className="relative font-medium leading-snug text-base text-left ">{heading}</h3>
                    {subheading && <p className="relative text-sm text-left">{subheading}</p>}
                  </div>
                </div>
              return (
                <li key={heading} className=''>
                  {modal ?
                    <Modal button={button} modalContent={modal} />
                    : button
                  }
                </li>
              )
            })}
          </ol>
        </div>
      </section>
    </>
  )
}


const Earth = ({
  className,
  theta = 0.25,
  dark = 1,
  scale = 1.1,
  diffuse = 1.2,
  mapSamples = 40000,
  mapBrightness = 10,
  baseColor = [0.4, 0.6509, 1],
  markerColor = [1, 0, 0],
  glowColor = [0.2745, 0.5765, 0.898],
  width = 300,
}) => {
  const canvasRef = useRef(null);
  useEffect(() => {
    let width = 0;
    const onResize = () =>
      canvasRef.current && (width = canvasRef.current.offsetWidth);
    window.addEventListener('resize', onResize);
    onResize();
    let phi = 0;
    onResize();
    const globe = createGlobe(canvasRef.current, {
      devicePixelRatio: 2,
      width: width * 2,
      height: width * 2,
      phi: 0,
      theta: theta,
      dark: dark,
      scale: scale,
      diffuse: diffuse,
      mapSamples: mapSamples,
      mapBrightness: mapBrightness,
      baseColor: baseColor,
      markerColor: markerColor,
      glowColor: glowColor,
      opacity: 1,
      offset: [0, 0],
      markers: [],
      onRender: (state) => {
        state.phi = phi;
        phi += 0.003;
      },
    });

    return () => {
      globe.destroy();
    };
  }, []);
  return (
    <div
      className={`flex relative items-center justify-center w-full max-w-[350px] p-8 aspect-square mx-auto ${className}`}
    >
      <canvas
        ref={canvasRef}
        className='w-full h-full max-w-full aspect-square'
      />
    </div>
  );
};
